/*eslint-disable*/
import React from 'react'
import PropTypes from 'prop-types'

// components
import { Grid, Button } from '@mui/material'
import TextInputField from '../textInputField'
import ApplicationField from './components/applicationField'
import ButtonWithLoader from '../buttonWithLoader'
import Alert from '../Alert/Alert'

// helpers
import {
  validateGroup,
  validateGroupChange,
} from './helpers/groupForm.validators'
import { useIsMobileView } from '../../utils/isMobileView'

// styles
import styles from './groupForm.module.scss'

// hook
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'

function GroupForm(props) {
  const {
    group,
    setGroup,
    errors,
    setErrors,
    onSubmit,
    isSubmitting,
    onCancel,
    formFieldsConfig,
    primaryButtonLabel,
    applicationFieldKey,
    areFormValuesChanged,
    isSuccessful,
    showAlert,
    setShowAlert,
    alertBlurb,
    isEditPage,
  } = props

  const handleChange = (e) => {
    const { name, value } = e.target
    const updatedGroup = { ...group, [name]: value }
    const errorMsgs = validateGroupChange(updatedGroup, name)
    setErrors(errorMsgs)
    setGroup(updatedGroup)
  }

  const handleGroupChange = (e) => {
    const { name, value } = e.target
    const { application } = group
    if (!value.includes(`${application} - `)) {
      const updatedGroup = { ...group, groupName: `${application} - ` }
      setGroup(updatedGroup)
      return
    }
    const updatedGroup = { ...group, groupName: value }
    const errorMsgs = validateGroup(updatedGroup)
    setErrors(errorMsgs)
    setGroup(updatedGroup)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit()
  }

  const handleCancel = (e) => {
    e.preventDefault()
    onCancel()
  }

  const handleAlertClose = () => {
    setShowAlert(false)
  }

  const { t } = useTranslation()
  const isMobileView = useIsMobileView()

  return (
    <Grid className={isMobileView ? styles.mobileContainer : styles.container}>
      <h1 className={styles.header}>{isEditPage ? `${t('view-group-edit-button')}: ${group.groupName}` : t('create-group-title')}</h1>
      {showAlert && (
        <div style={{ paddingTop: '17px', paddingRight: '20px' }}>
          <Alert
            message=''
            alertStyle={isSuccessful ? "success-alert" : "error-alert"}
            headerText={isSuccessful ? "Success" : "Error"}
            blurb={alertBlurb}
            onClose={handleAlertClose}
            showClose
            customStyles={{
              marginBottom: '9px',
              width: '385px',
              fontSize: '14px',
              overflowWrap: 'anywhere',
            }}
          />
        </div>
      )}
      <Grid className={styles.formContainer}>
        {formFieldsConfig.showApplication && (
          <ApplicationField
            group={group}
            setGroup={setGroup}
            key={applicationFieldKey}
            errors={errors}
            inputPlaceholder={styles.inputPlaceholder}
          />
        )}
        <TextInputField
          className={styles.groupInput}
          label={t('create-group-name')}
          required={true}
          id={'groupName'}
          value={group.groupName}
          error={errors.groupName}
          onChange={handleGroupChange}
          disabled={!group.application}
          styles={{width: '385px', marginTop: '22px', height:'81px'}}
        />
        <TextInputField
          className={styles.groupInput}
          label={t('create-group-description')}
          required={true}
          id={'description'}
          value={group.description}
          error={errors.description}
          onChange={handleChange}
          disabled={!group.application}
          placeholder={t('create-group-description-placeholder')}
          multiLine
          rows={6}
          styles={{width: '385px', marginTop: '22px', height: '196px'}}
          inputPlaceholder={styles.inputPlaceholder}
        />
      </Grid>
      <Grid className={styles.buttonContainer}>
        <ButtonWithLoader
          onClick={handleSubmit}
          className="primary-btn"
          loading={isSubmitting}
          disabled={ !areFormValuesChanged}
          label={primaryButtonLabel}
          disableElevation={true}
          sx={{
            backgroundColor: '#eb1700',
            width: '128px',
            height: '48px',
            '&:hover': {
              backgroundColor: '#CC1400',
            },
            '&:disabled': {
              backgroundColor: '#665A47',
            },
            '&:focus': {
              backgroundColor: '#CC1400',
            },
          }}
        />
        <Button
          onClick={handleCancel}
          type="submit"
          className="secondary-btn"
          variant="contained"
          disabled={isSubmitting}
          disableElevation={true}
          sx={{
            marginLeft: '8px',
            color: '#000000',
            width: '128px',
            height: '48px',
            backgroundColor: 'rgba(98, 81, 55, 0.1)',
            '&:hover': {
              backgroundColor: 'rgba(102,90,71, 0.20)',
            },
            '&:disabled': {
              backgroundColor: 'rgba(138, 115, 92, 0.05)',
            },
            '&:focus': {
              backgroundColor: 'rgba(112, 99, 79, 0.1)',
            },
          }}
        >
          {t('create-group-button-cancle')}
        </Button>
      </Grid>
    </Grid>
  )
}

GroupForm.propTypes = {
  formFieldsConfig: PropTypes.object,
  primaryButtonLabel: PropTypes.string,
  areFormValuesChanged: PropTypes.bool,
  isEditPage: PropTypes.bool,
}

GroupForm.defaultProps = {
  formFieldsConfig: {},
  primaryButtonLabel: i18next.t('create-group-button-save-group'),
  areFormValuesChanged: false,
  isEditPage: false,
}

export default GroupForm
